<template>
	<transition name="slide-fade">
		<span v-if="loaded == 'true'">

			<div class="col-xs-12 grtit">
				<h2>PODCAST</h2>

				<ul class="col-xs-12 filtro" v-if="loaded_categorias=='true'">
					<li>
						<router-link :to="{ name: 'catpodcast' }" >
							Todos
						</router-link>
					</li>
					<li v-for="categoria in categorias" class="nonactive" v-bind:elpodcast="categoria.slug">
						<router-link :to="{ name: 'interna_podcast', params: { name:categoria.slug } }" >
							{{ categoria.name }}
						</router-link>
						<!-- <router-link v-else :to="{ name: 'catpodcast' }" >
							{{ categoria.name }}
						</router-link> -->

					</li>
				</ul>
			</div>
			<div class="col-xs-12 block reproductor" v-if="loaded_posts=='true'">
				<div class="container">
					<div class="rss-botones">
						<div v-if="LaCat.categoria_meta.hasOwnProperty('url_google_podcast')">
							<a v-bind:href="LaCat.categoria_meta.url_google_podcast">
								<img style="height:2%; width:2%" v-bind:src="theme_url+'/html/assets/img/btn-googlepodcast.png'">
							</a>
						</div>
						<div v-if="LaCat.categoria_meta.hasOwnProperty('url_itunes')">
							<a v-bind:href="LaCat.categoria_meta.url_itunes">
								<img style="height:2%; width:2%" v-bind:src="theme_url+'/html/assets/img/btn-itunespodcast.jpg'">
							</a>
						</div>
						<div v-if="LaCat.categoria_meta.hasOwnProperty('url_ivoox')">
							<a v-bind:href="LaCat.categoria_meta.url_ivoox">
								<img style="height:2%; width:2%" v-bind:src="theme_url+'/html/assets/img/btn-ivoox.png'">
							</a>
						</div>
						<div v-if="LaCat.categoria_meta.hasOwnProperty('url_spotify')">
							<a v-bind:href="LaCat.categoria_meta.url_spotify">
								<img style="height:2%; width:2%" v-bind:src="theme_url+'/html/assets/img/btn-spotify.png'">
							</a>
						</div>
					</div>
					<div class="row">
						<div class="player__playlist">
							<div class="compartir__player">
								<button><i class="icon share"></i></button>
								<ul>
									<li><a v-bind:href="'https://www.facebook.com/sharer/sharer.php?u=https://www.obedira.com.py/interna_reflexion/'+LaCat.slug" target="_blank"><i class="fa fa-facebook"></i></a></li>
									<li><a v-bind:href="'https://twitter.com/share?url='+LaCat.link+'&text='+LaCat.name" target="_blank"><i class="fa fa-twitter"></i></a></li>
									<li class="itemwa"><a v-bind:href="'whatsapp://send?text='+LaCat.link"><i class="fa fa-whatsapp"></i></a></li>
								</ul>
							</div>
							<a href="#" class="fav__player"><i v-bind:programa="LaCat.id" class="icon star"></i></a>
							<ul class="playlist">

								<li v-for="audio in posts" v-bind:data-cover="audio.better_featured_image.media_details.sizes['306x307'].source_url" v-bind:data-descripcion="audio.soloexcerpt" class="col-xs-12 npd">
									<a v-bind:href="audio.post_meta_fields._enclosure_mp3">
										<span class="titulo" v-html="audio.title.rendered"></span>
										<span class="autor" v-if="audio.acf.locutor[0].post_title!=null">{{ audio.acf.locutor[0].post_title}} </span>
										<span class="autor" v-else>---</span>
										<span class="fecha" v-html="audio.fechaconformatocorto"></span>
										<span class="duracion">{{audio.post_meta_fields._duration.duration}}</span>
										<span class="descarga">
											<button type="button">
												Descargar
											</button>
										</span>
									</a>
								</li>

							</ul>
						</div>
					</div>
				</div>
			</div>


			<div class="col-md-12">

				<nav aria-label="Page navigation" v-if="totalPages > 1">
					<ul class="pagination">
						<li v-on:click="rtShowFirst()" id="rtShowFirst">
							&laquo;&laquo;
						</li>
						<li v-if="showPrev=='true'" v-on:click="rtShowPrev()" id="rtShowPrev">
							&laquo;
						</li>
						<li>
							{{ currentPage }} - {{ totalPages }}
						</li>
						<li v-if="showNext=='true'" v-on:click="rtShowNext()" id="rtShowNext">
							&raquo;
						</li>
						<li v-on:click="rtShowLast()" id="rtShowLast">
							&raquo;&raquo;
						</li>
					</ul>
				</nav>
			</div>


		</span>
	</transition>

</template>

<script>
export default {
	mounted: function() {
		const vm = this;
		if ( vm.$route.params.name ) {
			vm.getCatId( vm.$route.params.name );
		}
	},
	watch: {
		// call method if the route changes
		'$route': 'reInitialize'
	},
	data() {
		return {
			theme_url:rtwp.theme_url,
			posts: {},
			loaded: 'false',
			loaded_posts: 'false',
			loaded_categorias: 'false',
			pageTitle: '',
			totalCount: '',
			catName: '',
			LaCat: '',
			categorias:{},
			currentPage: '',
			prevPage: '',
			nextPage: '',
			showNext: 'false',
			showPrev: 'false',
			postPerPage: '12',
			totalPages: '',
		};
	},
	methods: {
		reInitialize: function() {
			this.getCatId( this.$route.params.name );
		},
		getPosts: function( catId, pageNumber = 1 ) {
			const vm = this;
			vm.loaded_posts = 'false';
			vm.$http.get( 'wp/v2/posts', {
				params: { categories: catId, page: pageNumber,per_page: vm.postPerPage }
			} )
			.then( ( res ) => {
				vm.posts = res.data;
				vm.loaded_posts = 'true';
				vm.totalPages = res.headers[ 'x-wp-totalpages' ];
				vm.showNext='true';
				vm.showPrev='true';
				if ( pageNumber <= parseInt( vm.totalPages ) ) {
					vm.currentPage = parseInt( pageNumber );
				} else {
					vm.currentPage = 1;
				}
				vm.$nextTick(function(){
					jQuery(".player__playlist").musicPlayer();
					init_attach();
				});
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );

		},
		getCatId: function( name ) {
			const vm = this;
			vm.catName = name;
			vm.loaded = 'false';
			vm.$http.get( 'wp/v2/categories/?slug=' + name )
			.then( ( res ) => {
				vm.totalCount = (res.count);
				res = res.data[ 0 ];
				vm.catName=res.name;
				vm.pageTitle = vm.catName;
				vm.loaded = 'true';
				vm.$store.commit( 'rtChangeTitle', vm.pageTitle );
				vm.getPosts( res.id, 1 );
				this.getCats(res.parent);
				vm.LaCat=res;
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		},
		rtShowNext: function( event ) {
			const vm = this;
			if ( vm.currentPage < vm.totalPages ) {
				vm.currentPage = vm.currentPage + 1;
				vm.getPosts(vm.LaCat.id,vm.currentPage);
				//vm.$router.push( { 'name': 'category', params: { categories: vm.LaCat.id, page: vm.currentPage,per_page: vm.postPerPage } } );
			}
		},
		rtShowPrev: function( event ) {
			const vm = this;
			if ( vm.currentPage != 1 ) {
				vm.currentPage = vm.currentPage - 1;
				vm.getPosts(vm.LaCat.id,vm.currentPage);
				//vm.$router.push( { 'name': 'category', params: { categories: vm.LaCat.id, page: vm.currentPage,per_page: vm.postPerPage } } );
			}
		},
		rtShowFirst: function( event ) {
			const vm = this;
				vm.getPosts(vm.LaCat.id,1);
		},
		rtShowLast: function( event ) {
			const vm = this;
				vm.getPosts(vm.LaCat.id,vm.totalPages);
		},
		getCats:function (pid){
			// http://104.236.216.165/wp-json/wp/v2/categories/
			const vm = this;
			vm.loaded_categorias = 'false';
			vm.$http.get( 'wp/v2/categories/', {
				params: { hide_empty: true, parent:pid }
			} )
			.then( ( res ) => {
				vm.loaded_categorias='true';
				vm.categorias=res.data;
				vm.$nextTick(function(){
					jQuery("li[elpodcast='"+vm.LaCat.slug+"']").addClass('active');
				});
			} )
			.catch( ( res ) => {
				// console.log( `Something went wrong : ${ res }` );
			} );
		}
	},
};
</script>



// WEBPACK FOOTER //
// interna_podcast.vue?e316297e